module.exports = __webpack_public_path__ + "static/media/stop-bullying.de6a5ebb.jpeg";